import "./AssetProtection.module.css";
import Header from "@/reusable_sections/Header";
import ShieldingYourSuccess from "./sections/ShieldingYourSuccess";
import FloridaProtectionStrategies from "./sections/FloridaProtectionStrategies";
import Footer from "@/reusable_sections/Footer";
export default function AssetProtectionPage() {
  return <div>
      <Header />
      <ShieldingYourSuccess />
      <FloridaProtectionStrategies />
      <Footer />
    </div>;
}